module.exports = __webpack_public_path__ + "img/healthcare_icon_1.a27eb2a2.png";